import usePrivateAxios from "@/common/api/usePrivateAxios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";

type UseEquipmentModelFipePricesProps<T> = {
  id: string
  mapper?: (data: any) => T,
}

const useEquipmentModelFipePrices = <T,>({
  id,
  mapper = Mapper.default<T>()
}: UseEquipmentModelFipePricesProps<T>) => {
  const privateAxios = usePrivateAxios()

    const {
      data: { data, meta} = defaultTransformerResponse<T>(),
      isPending,
      ...rest
    } = useQuery({
    queryKey: ['equipmentModelFipePrices', id],
    queryFn: () => privateAxios.get(`/equipment_models/${id}/fipe_prices`),
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
}

export default useEquipmentModelFipePrices